export enum OnboardingPathsEnum {
  HOME = "/",
}
